export const avatarFrameRender = (frame) => {
  switch (frame) {
    case 'Rare':
      return {
        backgroundImage: `url(/assets/images/faction/BlueGlow.webp)`,
        padding: 15,
      };
    case 'Epic':
      return {
        backgroundImage: `url(/assets/images/faction/PurpleGlow.webp)`,
        padding: 20,
      };
    case 'Legendary':
      return {
        backgroundImage: `url(/assets/images/faction/OrangeGlow.webp)`,
        padding: 15,
      };
    default:
      return {
        backgroundImage: 'none',
      };
  }
};

/**
 *Avatar Glow Renderer
 */
export const avatarGlowRender = (rarity) => {
  switch (rarity) {
    case 'Rare':
      return {
        border: 'solid 2px #aee9ff',
        boxShadow: '0 0 10px 7px #aee9ff',
      };
    case 'Epic':
      return {
        border: 'solid 2px #b375da',
        boxShadow: '0 0 20px #b375da',
      };
    case 'Legendary':
      return {
        border: 'solid 2px #8e7c3b',
        boxShadow: '0 0 20px #8e7c3b',
      };
    default:
      return;
  }
};
